export enum RegraTributariaErrorCodeEnum {
    SeedPendente = 1,
}
